// removed by extract-text-webpack-plugin
module.exports = {"SideNavigation":"_26AOk","SideNavDisabled":"_1DW5k","SideNavActive":"_2jPbI","SideNavMobile":"_1yfqY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/SideNavigation/SideNavigation.scss
// module id = 679
// module chunks = 0